import type { ColumnSortValue } from '../DataTable.types'

export function isBlankSortValue(value: ColumnSortValue): boolean {
  return value === null || value === undefined || value === ''
}
